import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './EventPopup.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import IconClosePrimary from '../../components/atoms/Icons/IconClosePrimary';
var EventPopup = function EventPopup(_ref) {
  var heading = _ref.heading,
    copy = _ref.copy,
    ctaLabel = _ref.ctaLabel,
    ctaLink = _ref.ctaLink;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    close = _React$useState2[0],
    setClose = _React$useState2[1];
  var processClick = function processClick() {
    setClose(true);
  };

  /* React.useEffect(() => {
  }, []); */

  if (close) return null;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "events-popup"
  }, /*#__PURE__*/React.createElement("span", {
    className: "events-popup__close",
    onClick: processClick
  }, /*#__PURE__*/React.createElement(IconClosePrimary, null)), /*#__PURE__*/React.createElement("h2", {
    className: "events-popup__title"
  }, heading), /*#__PURE__*/React.createElement("p", {
    className: "body-medium events-popup__copy"
  }, copy), /*#__PURE__*/React.createElement("a", {
    className: "btn btn-primary",
    href: ctaLink,
    onClick: processClick,
    "aria-label": "CTA",
    "aria-labelledby": "CTA"
  }, ctaLabel)));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "clzk9xu";
var ltrStyles = "l3uyxh6";
var rtlStyles = "r7fozbm";
export default EventPopup;